<template>
    <div class="offer search" :class="{small}">
        <nuxt-link :to="offer.link" class="picture-container">
            <catalog-switching-picture class="main-picture" :eager="top" :images="offer.pictures" size="offer-flat"></catalog-switching-picture>
            <catalog-offer-badges :offer></catalog-offer-badges>
            <catalog-favorite-btn :id="offer.id"></catalog-favorite-btn>
            <img class="discount-icon" v-if="offer.price.complect?.icon" :src="offer.price.complect.icon">
        </nuxt-link>

        <nuxt-link class="title" :to="offer.link">
            <span>{{offer.title.text}}</span>
            <div class="offer-feature-block" v-if="offer.title.badges.length">
                <span v-for="t of offer.title.badges" :key="t">{{ t }}</span>
            </div>
        </nuxt-link>

        <div class="buy-block">
            <catalog-offer-price v-if="offer.price" :price="offer.price"></catalog-offer-price>
            <catalog-buy-btn-small :id="offer.id"></catalog-buy-btn-small>
        </div>

        <catalog-yandex-pay-badge v-if="yandexStore.isSplitActive" :price="offer.price.price" size="s"></catalog-yandex-pay-badge>
    </div>
</template>

<script lang="ts" setup>
import { useYandexPayStore } from '~/store/yandexPayStore';
import type { IOffer } from '~~/types/catalog';

const props = defineProps<{
    offer: IOffer;
    top?: boolean;
    small?: boolean;
}>()

const yandexStore = useYandexPayStore();

</script>

<style lang="scss" src="./style.scss" scoped></style>

<style lang="scss" scoped>

.offer.search {
    width: unset;

    .title {
        font-size: 16px;
        height: 48px;
    }

    :deep(.offer-badges) > * {
        font-size: 14px;
        height: 24px;
    }
}

</style>